export const SPECIAL_VALUES = {
  noMilestoneData: {
    id: 'no-milestone',
    title: 'No milestone',
    closed: false,
  },
  noLabelsData: {
    id: 'no-labels',
    name: 'No labels',
    color: 'ededed',
    description: 'Issues with no labels',
  },
  noAssigneeData: {
    id: 'no-assignee',
    login: 'No assignees',
    avatarUrl: '',
  },
  noMatchData: {
    id: 'no-match-item',
    avatarUrl: '',
    description: 'Filter by user',
  },
  noTypeData: {
    id: 'no-type',
    name: 'No type',
    color: 'ededed',
    description: 'Issues with no type',
  },
}
